import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import InsightPage from './pages/InsightPage';

const OverviewTab = lazy(() => import('./pages/OverviewTab'));
const InstitutesTab = lazy(() => import('./pages/InstitutesTab'));
const SubjectsTab = lazy(() => import('./pages/SubjectsTab'));
const SurveysTab = lazy(() => import('./pages/SurveysTab'));
const QuestionInsightsTab = lazy(() => import('./pages/QuestionInsightsTab'));

const TabFallback: React.FC = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
    <CircularProgress />
  </Box>
);

export const InsightRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<InsightPage />}>
        <Route
          index
          element={
            <Suspense fallback={<TabFallback />}>
              <OverviewTab />
            </Suspense>
          }
        />
        <Route
          path="overview"
          element={
            <Suspense fallback={<TabFallback />}>
              <OverviewTab />
            </Suspense>
          }
        />
        <Route
          path="institutes"
          element={
            <Suspense fallback={<TabFallback />}>
              <InstitutesTab />
            </Suspense>
          }
        />
        <Route
          path="subjects"
          element={
            <Suspense fallback={<TabFallback />}>
              <SubjectsTab />
            </Suspense>
          }
        />
        <Route
          path="surveys"
          element={
            <Suspense fallback={<TabFallback />}>
              <SurveysTab />
            </Suspense>
          }
        />
        <Route
          path="question-insights"
          element={
            <Suspense fallback={<TabFallback />}>
              <QuestionInsightsTab />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};
